import React from 'react';
import { Box, Tabs, Tab } from '@mui/material';
import theme from '../../theme';

const TabButton = ({
  activeTab,
  onTabChange,
  tabs,
  children,
  centered = true,
  marginTop = 3.75,
  sx = {},
}) => {
  const currentTab = tabs.find((tab) => tab.id === activeTab);

  return (
    <Box>
      <Box
        sx={{
          overflowX: 'auto',
          overflowY: 'hidden',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
          scrollbarWidth: 'none', // Firefox
          msOverflowStyle: 'none', // IE/Edge
        }}
      >
        <Tabs
          value={activeTab}
          onChange={(e, newValue) => onTabChange(newValue)}
          variant="scrollable"
          scrollButtons={false}
          sx={{
            ...sx,
            minHeight: 'auto', // indicator 높이 제거
            '& .MuiTabs-indicator': {
              display: 'none',
            },
            '& .MuiTabs-flexContainer': {
              justifyContent: { xs: 'flex-start', md: centered ? 'center' : 'flex-start' },
              gap: { xs: 0.75, md: 1 },
              minWidth: 'fit-content',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              lineHeight: '1',
              minHeight: 'auto',
              minWidth: 'auto',
              px: { xs: 1.25, md: 2 },
              py: { xs: 1, md: 1.5 },
              fontSize: { xs: '13px', md: '16px' },
              fontWeight: 700,
              borderRadius: '4px',
              border: '1px solid',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              color: `${theme.palette.black[9]}`,
              backgroundColor: `${theme.palette.surface.main}`,
              borderColor: `${theme.palette.black[9]}`,
              flexShrink: 0,
              '&.Mui-selected': {
                color: 'var(--pp-button-primary-fg)',
                backgroundColor: 'var(--pp-button-primary-bg)',
                borderColor: `${theme.palette.black[9]}`,
              },
            },
          }}
        >
          {tabs.map((tab) => (
            <Tab key={tab.id} value={tab.id} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      <Box sx={{ mt: marginTop }}>
        {/* 현재 탭의 tabButton 표시 */}
        {currentTab?.tabButton && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-start',
              fontSize: '22px',
              fontWeight: 'medium',
              mb: { xs: 2.5, lg: 3.75 },
            }}
          >
            {currentTab.tabButton}
          </Box>
        )}

        <Box>{children}</Box>
      </Box>
    </Box>
  );
};

export default TabButton;
